import React from 'react'
import cn from 'classnames'

import { useTranslation } from '@mc/i18n'
import { Icon } from '@mc/design-system'

export const SessionsBanner = ({
  outputDescription,
}: {
  outputDescription: string
}) => {
  const { t } = useTranslation('@mc/next')

  const badges = [
    {
      subtitle: outputDescription,
      description: t('sessions.banner.outcomes.description'),
      icon: 'checkbox',
    },
    {
      subtitle: t('sessions.banner.structure.subtitle'),
      description: t('sessions.banner.structure.description'),
      icon: 'calendar',
    },
    {
      subtitle: t('sessions.banner.community.subtitle'),
      description: t('sessions.banner.community.description'),
      icon: 'people',
    },
    {
      subtitle: t('sessions.banner.difficulty.subtitle'),
      description: t('sessions.banner.difficulty.description'),
      icon: 'levels',
    },
  ]

  const badgesDisplay = badges.map(({ subtitle, description, icon }) => (
    <li key={icon} className='mc-p-6'>
      <Icon
        kind={icon}
        className='mc-mr-2 mc-text-color--gray-500 mc-icon--6'
      />

      <p className='mc-mt-2 mc-mb-1 mc-text--bold'>{subtitle}</p>
      <p className='mc-opacity--muted mc-text-color--gray-100'>{description}</p>
    </li>
  ))

  const cls = ({ gteMD }: { gteMD: boolean }) =>
    cn({ 'd-flex mc-text--center': gteMD, 'mc-text--left': !gteMD }, 'mc-pb-6')

  return (
    <>
      <div className='d-block d-md-none'>
        <ol className={cls({ gteMD: false })}>{badgesDisplay}</ol>
      </div>
      <div className='d-none d-md-block'>
        <ol className={cls({ gteMD: true })}>{badgesDisplay}</ol>
      </div>
    </>
  )
}
